import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUp, AtSign, Sparkles } from "lucide-react";
import Speeddial from "./ui/SpeedDial";
import whatsapp from "./../assets/whatsapp.png";

const SpeedDailDemo = () => {
    const navigate = useNavigate();

    const actionButtons = [
        {
            icon: <img src={whatsapp} alt="WhatsApp" className="size-6" />,
            label: "Contact",
            key: "contact",
            action: () => {
                const phoneNumber = "+919740026068";
                const message = "Hello! I'd like to know more about your ERP/CRM solutions.";
                const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
                window.open(whatsappUrl, "_blank");
            },
        },
        {
            icon: <AtSign size={20} />,
            label: "Email",
            key: "email",
            action: () => {
                window.location.href = "mailto: parnetsales@gmail.com";
            },
        },
        {
            icon: <Sparkles size={20} className="text-[#363090]" />,
            label: "Ask AI",
            key: "askAI",
            action: () => navigate('/ask-ai'),
        },
        {
            icon: <ArrowUp size={20} />,
            label: "Top",
            key: "goToTop",
            action: () => {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            },
        },
    ];

    return (
        <div className="flex items-center justify-center">
            <Speeddial direction="up" actionButtons={actionButtons} />
        </div>
    );
};

export default SpeedDailDemo;
